<template>
  <div>
    <v-row dense>
      <v-col cols="4">
        <phone-input
          v-model="form.mobile_phone"
          :label="$t('PROFILE.MOBILE_PHONE')"
          :readonly="readonly"
          :error-messages="errors.mobile_phone"
          @input="updateValue('mobile_phone', $event)"
        ></phone-input>
      </v-col>
      <v-col cols="4">
        <phone-input
          v-model="form.phone"
          :label="$t('PROFILE.PHONE')"
          :readonly="readonly"
          :error-messages="errors.phone"
          @input="updateValue('phone', $event)"
        ></phone-input>
      </v-col>
      <v-col cols="4">
        <v-select
          v-model="form.marital_status_id"
          :items="marital_statuses"
          item-text="name"
          item-value="id"
          :clearable="!readonly"
          :label="$t('PROFILE.MARITAL_STATUS')"
          :readonly="readonly"
          :error-messages="errors.marital_status"
          @change="updateValue('marital_status_id', $event)"
        ></v-select>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="4">
        <v-text-field
          v-model="form.street"
          :label="$t('PROFILE.STREET')"
          :readonly="readonly"
          :error-messages="errors.street"
          @input="updateValue('street', $event)"
        ></v-text-field>
      </v-col>
      <v-col cols="4">
        <zip-code-input
          v-model="form.zip"
          :readonly="readonly"
          :error-messages="errors.zip"
          @input="updateValue('zip', $event)"
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          v-model="form.city"
          :label="$t('PROFILE.CITY')"
          :readonly="readonly"
          :error-messages="errors.city"
          @input="updateValue('city', $event)"
        ></v-text-field>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mask } from 'vue-the-mask';
import { mapCacheActions } from 'vuex-cache';
import formEditable from '@/modules/_global/mixins/form-editable';
import i18nRefreshData from '@/modules/_global/mixins/i18nRefreshData';
import ZipCodeInput from "@/modules/_global/_components/zip/ZipCodeInput";

export default {
  name: 'PersonalProfileForm',

  directives: {
    mask
  },

  components: {
    ZipCodeInput,
    PhoneInput: () => import('@/modules/_global/_components/phone/PhoneInput')
  },

  mixins: [formEditable, i18nRefreshData],

  data() {
    return {
      form: {},
      liveswith: [],
      marital_statuses: []
    };
  },

  mounted() {
    this.refreshData();
  },

  methods: {
    ...mapCacheActions('person', ['getMaritalStatuses']),

    refreshData() {
      this.getMaritalStatuses().then(({ data }) => {
        this.marital_statuses = data.data;
      });
    }
  }
};
</script>

<style scoped></style>
